import { createApiClient } from '@uznali/api-client';

import { env } from '@shared/config/env';
import { tokenStore } from '@shared/lib/auth/token-store';

export const apiClient = createApiClient({
  baseURL: env.apiUrl,
  getTokens: () => tokenStore.getForRequest(),
  setTokens: (tokens) => tokenStore.updateFromRefresh(tokens),
});
